module.exports = __webpack_public_path__ + "assets/img/putdown.f9552daa.svg";